import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { kisiQueryKeys } from "./kisiQueryKeys";

export function useQueryKisiGroupList(
  {
    api,
    clubId,
  }: {
    api: ApiType;
    clubId: number;
  },
  queryOpts?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: kisiQueryKeys.groups(),
    queryFn: async () => {
      const result = await api.kisiApi.fetchGroups(clubId);
      return result.data;
    },
    initialData: [],
    ...queryOpts,
  });
}
